export const DEFAULT_MIN_PASSWORD_SCORE = 3;
export const DEFAULT_MIN_PASSWORD_LENGTH = 10;
export const SERVICE_ACCOUNT_MIN_PASSWORD_LENGTH = 25;